/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "../Styles/Components/Header.css";
import Cookies from "js-cookie";
import "../Styles/ut-genel.css";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
      isMobile: false,
      isUserDropdownOpen: false,
      isim: "",
      soyisim: "",
    };
  }
  loadName = async () => {
    const storedName = localStorage.getItem("isim");
    const storedSurname = localStorage.getItem("soyisim");

    if (storedName && storedSurname) {
      this.setState({ isim: storedName, soyisim: storedSurname });
      return;
    }

    const token = Cookies.get("token");
    // if (!token) {
    //   window.location.href = "/login";
    //   return;
    // }

    if (token) {
      try {
        const base64Url = token.split('.')[1];
        if (base64Url) {
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
          const decoded = JSON.parse(jsonPayload);
          if (decoded && (decoded.name || decoded.isim)) {
            const fullName = decoded.name || decoded.isim;
            const parts = fullName.trim().split(" ");
            const fallbackIsim = parts[0] || fullName;
            const fallbackSoyisim = parts.slice(1).join(" ") || "";
            this.setState({ isim: fallbackIsim, soyisim: fallbackSoyisim });
          }
        }
      } catch (e) {}

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/generalWeb/get-name`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token }),
          }
        );

        const data = await response.json();

        if (data.m === "basarili") {
          const isim = data.data[0].isim;
          const soyisim = data.data[0].soyisim;
          this.setState({ isim, soyisim });

          localStorage.setItem("isim", isim);
          localStorage.setItem("soyisim", soyisim);
        }
      } catch (err) {
        console.error("API Hatası:", err);
      }
    }
  };

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
    }));
  };

  closeMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false });
  };

  toggleUserDropdown = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      isUserDropdownOpen: !prevState.isUserDropdownOpen,
    }));
  };

  closeUserDropdown = () => {
    this.setState({ isUserDropdownOpen: false });
  };

  checkIfMobile = () => {
    const isMobile = window.innerWidth <= 767;
    this.setState({ isMobile });
  };

  handleLogout = () => {
    Cookies.remove("token", { path: "/" });
    Cookies.remove("token");
    localStorage.removeItem("token");
    localStorage.removeItem("isim");
    localStorage.removeItem("soyisim");
    this.closeUserDropdown();
    if (this.props.onLogout) {
      this.props.onLogout();
    }
    window.location.reload();
  };

  handleProfileClick = () => {
    this.closeUserDropdown();
    window.location.href = "/profile";
  };

  componentDidMount() {
    this.loadName();
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
    document.body.addEventListener("click", this.handleOutsideClick);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkIfMobile);
    document.body.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick = (e) => {
    if (
      this.state.isMobileMenuOpen &&
      !e.target.closest(".header-area") &&
      !e.target.closest(".menu-trigger")
    ) {
      this.setState({ isMobileMenuOpen: false });
    }

    if (
      this.state.isUserDropdownOpen &&
      !e.target.closest(".user-dropdown-container")
    ) {
      this.setState({ isUserDropdownOpen: false });
    }
  };

  renderUserSection = () => {
    const isLoggedIn = Boolean(
      Cookies.get("token") || this.props.isLoggedIn
    );
    const { isUserDropdownOpen } = this.state;

    if (isLoggedIn) {
      return (
        <li className="user-dropdown-container">
          <a
            href="#"
            onClick={this.toggleUserDropdown}
            className="user-dropdown-trigger user-auth-button"
          >
            <i className="fa-solid fa-user"></i>{" "}
            {this.state.isim || this.state.soyisim ? (this.state.isim + " " + this.state.soyisim).trim() : "Kullanıcı"}
            <i
              className={`fa-solid fa-chevron-down dropdown-arrow ${isUserDropdownOpen ? "open" : ""
                }`}
            ></i>
          </a>

          {isUserDropdownOpen && (
            <div className="user-dropdown-menu">
              <ul>
                <li>
                  <a
                    href="#"
                    onClick={() => (window.location.href = "/profil")}
                  >
                    <i className="fa-solid fa-user"></i>
                    Profil
                  </a>
                </li>

                {/* <li>
      <a
        href="#"
        onClick={() => (window.location.href = "/payment-plan")}
      >
        <i
          className={`fa-solid ${
            this.props.isPaymentActive
              ? "fa-check-circle"
              : "fa-times-circle"
          }`}
        ></i>
        Üyelik Durumu (
        {this.props.isPaymentActive ? "Aktif" : "Pasif"})
      </a>
    </li> */}

                {/* <li>
      <a href="#" onClick={() => window.location.href = '/online-meeting-links'}>
        <i className="fa-solid fa-video"></i> Online Toplantı Linkleri
      </a>
    </li> */}

                <li>
                  <a
                    href="#"
                    onClick={this.handleLogout}
                    className="logout-item"
                  >
                    <i className="fa-solid fa-sign-out-alt"></i> Çıkış Yap
                  </a>
                </li>
              </ul>
            </div>
          )}
        </li>
      );
    } else {
      return (
        <>
          <li>
            <a
              href="#"
              onClick={() => (window.location.href = "/register")}
              className="user-auth-button"
            >
              <i className="fa-solid fa-user-plus"></i> Kayıt Ol
            </a>
          </li>
          <li>
            <a
              href="#"
              onClick={() => (window.location.href = "/login")}
              className="user-auth-button"
            >
              <i className="fa-solid fa-user"></i> Giriş Yap
            </a>
          </li>
        </>
      );
    }
  };

  renderMobileUserSection = () => {
    const isLoggedIn = Boolean(
      Cookies.get("token") || this.props.isLoggedIn
    );

    if (isLoggedIn) {
      return (
        <>
          <li>
            <span className="mobile-user-name">
              <i className="fa-solid fa-user"></i>{" "}
              {this.state.isim || this.state.soyisim ? (this.state.isim + " " + this.state.soyisim).trim() : "Kullanıcı"}
            </span>
          </li>
          <li>
            <a href="#" onClick={() => (window.location.href = "/profil")}>
              <i className="fa-solid fa-user-circle"></i> Profilim
            </a>
          </li>

          <li>
            <a href="#" onClick={this.handleLogout}>
              <i className="fa-solid fa-sign-out-alt"></i> Çıkış Yap
            </a>
          </li>
        </>
      );
    } else {
      return (
        <>
          <li>
            <a href="#" onClick={() => (window.location.href = "/register")}>
              <i className="fa-solid fa-user-plus"></i> Kayıt Ol
            </a>
          </li>
          <li>
            <a href="#" onClick={() => (window.location.href = "/login")}>
              <i className="fa-solid fa-user"></i> Giriş Yap
            </a>
          </li>
        </>
      );
    }
  };

  render() {
    const { isMobileMenuOpen } = this.state;
    const isLoggedIn = Boolean(
      Cookies.get("token") || this.props.isLoggedIn
    );

    return (
      <>
        <header className="header-area">
          <div className="container h-100">
            <div className="row h-100">
              <div className="col-12 h-100">
                <nav className="main-nav h-100">
                  <a href="/" className="logo">
                    <img
                      src="/Assets/Images/ut.png"
                      alt=""
                      id="header-logo-img"
                    />
                  </a>
                  <ul className="nav">
                    <li>
                      <NavLink to="/" end activeclassname="active">
                        Ana Sayfa
                      </NavLink>
                    </li>
                    {isLoggedIn && (
                      <li>
                        <NavLink to="/egitimler" activeclassname="active">
                          Eğitimler
                        </NavLink>
                      </li>
                    )}
                    {isLoggedIn && (
                      <li>
                        <NavLink to="/afisler" activeclassname="active">
                          Afişler
                        </NavLink>
                      </li>
                    )}
                    {isLoggedIn && (
                      <li>
                        <NavLink to="/takvim" activeclassname="active">
                          Takvim
                        </NavLink>
                      </li>
                    )}
                    {isLoggedIn && (
                      <li>
                        <NavLink to="/cark" activeclassname="active">
                          Çark
                        </NavLink>
                      </li>
                    )}

                    {/* <li>
                      <NavLink to="/etkinlikler" activeclassname="active">
                        Etkinlikler
                      </NavLink>
                    </li> */}
                    <li>
                      <NavLink to="/ofislerimiz" activeclassname="active">
                        Ofislerimiz
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/anlasmali-kurumlar" activeclassname="active">
                        Anlaşmalı Kurumlar
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/iletisim" activeclassname="active">
                        İletişim
                      </NavLink>
                    </li>

                    {this.renderUserSection()}
                  </ul>
                  <a
                    className={`menu-trigger ${isMobileMenuOpen ? "active" : ""
                      }`}
                    onClick={this.toggleMobileMenu}
                  >
                    <span>Menu</span>
                  </a>
                </nav>
              </div>
            </div>
          </div>

          <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
            <ul className="mobile-nav">
              <li>
                <NavLink
                  to="/"
                  end
                  activeclassname="active"
                  onClick={this.closeMobileMenu}
                >
                  Ana Sayfa
                </NavLink>
              </li>
              {isLoggedIn && (
                <li>
                  <NavLink
                    to="/egitimler"
                    activeclassname="active"
                    onClick={this.closeMobileMenu}
                  >
                    Eğitimler
                  </NavLink>
                </li>
              )}
              {isLoggedIn && (
                <li>
                  <NavLink
                    to="/afisler"
                    activeclassname="active"
                    onClick={this.closeMobileMenu}
                  >
                    Afişler
                  </NavLink>
                </li>
              )}
              {isLoggedIn && (
                <li>
                  <NavLink
                    to="/takvim"
                    activeclassname="active"
                    onClick={this.closeMobileMenu}
                  >
                    Takvim
                  </NavLink>
                </li>
              )}
              {isLoggedIn && (
                <li>
                  <NavLink
                    to="/cark"
                    activeclassname="active"
                    onClick={this.closeMobileMenu}
                  >
                    Çark
                  </NavLink>
                </li>
              )}
              {/* 
              <li>
                <NavLink
                  to="/etkinlikler"
                  activeclassname="active"
                  onClick={this.closeMobileMenu}
                >
                  Etkinlikler
                </NavLink>
              </li> */}
              <li>
                <NavLink
                  to="/ofislerimiz"
                  activeclassname="active"
                  onClick={this.closeMobileMenu}
                >
                  Ofislerimiz
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/anlasmali-kurumlar"
                  activeclassname="active"
                  onClick={this.closeMobileMenu}
                >
                  Anlaşmalı Kurumlar
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/iletisim"
                  activeclassname="active"
                  onClick={this.closeMobileMenu}
                >
                  İletişim
                </NavLink>
              </li>

              {this.renderMobileUserSection()}
            </ul>
          </div>
        </header>
      </>
    );
  }
}
